var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFaq(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 16.2016H1.8V4.50156C1.8 4.00656 1.395 3.60156 0.9 3.60156C0.405 3.60156 0 4.00656 0 4.50156V16.2016C0 17.1916 0.81 18.0016 1.8 18.0016H13.5C13.995 18.0016 14.4 17.5966 14.4 17.1016C14.4 16.6066 13.995 16.2016 13.5 16.2016Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2001 0H5.4001C4.4101 0 3.6001 0.81 3.6001 1.8V12.6C3.6001 13.59 4.4101 14.4 5.4001 14.4H16.2001C17.1901 14.4 18.0001 13.59 18.0001 12.6V1.8C18.0001 0.81 17.1901 0 16.2001 0ZM10.8091 11.7C10.2781 11.7 9.8641 11.277 9.8641 10.755C9.8641 10.224 10.2871 9.819 10.8091 9.819C11.3401 9.819 11.7451 10.224 11.7451 10.755C11.7361 11.277 11.3401 11.7 10.8091 11.7ZM13.0591 6.147C12.4921 6.984 11.9521 7.236 11.6551 7.776C11.5831 7.902 11.5381 8.01 11.5111 8.217C11.4661 8.568 11.1871 8.829 10.8361 8.829H10.8091C10.4131 8.829 10.0981 8.487 10.1341 8.091C10.1611 7.839 10.2151 7.578 10.3591 7.335C10.7281 6.678 11.4211 6.291 11.8261 5.715C12.2581 5.103 12.0151 3.969 10.8001 3.969C10.2511 3.969 9.8911 4.257 9.6661 4.599C9.4951 4.86 9.1531 4.95 8.8651 4.824C8.4871 4.662 8.3251 4.194 8.5591 3.861C9.0181 3.195 9.7831 2.7 10.7911 2.7C11.8981 2.7 12.6631 3.204 13.0501 3.834C13.3831 4.383 13.5721 5.391 13.0591 6.147Z",
    fill: "url(#paint1_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: -0.62,
    y1: -1.6623,
    x2: 14.9997,
    y2: -1.52653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.122751,
    stopColor: "#0F62FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B5BD2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 2.9801,
    y1: -5.26386,
    x2: 18.5998,
    y2: -5.1281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.122751,
    stopColor: "#0F62FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B5BD2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaq);
export default __webpack_public_path__ + "static/media/faq.cddc706bdfe9410ffd34d3567c4652ab.svg";
export { ForwardRef as ReactComponent };